import { useTranslation } from 'react-i18next';
import { ChevronDown } from 'lucide-react';

const QUESTIONS = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'] as const;

export function Faq() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden border-t border-border bg-muted/30 dark:bg-muted/10">
      <div aria-hidden className="pointer-events-none absolute inset-x-0 top-0 -z-0">
        <div className="mx-auto h-64 max-w-3xl bg-gradient-to-b from-rose-200/40 via-orange-200/20 to-transparent blur-3xl dark:from-rose-500/10 dark:via-orange-500/5" />
      </div>
      <div className="relative mx-auto max-w-3xl px-4 py-16 md:py-24">
        <div className="mb-10 text-center md:mb-14">
          <p className="text-sm font-semibold uppercase tracking-wider text-rose-600 dark:text-rose-400">
            {t('home.faq.eyebrow')}
          </p>
          <h2 className="mt-2 font-display text-3xl font-extrabold tracking-tight md:text-4xl">
            {t('home.faq.title')}
          </h2>
        </div>

        <div className="divide-y divide-border overflow-hidden rounded-2xl border border-border bg-card">
          {QUESTIONS.map((q) => (
            <details key={q} className="group px-5 py-4 md:px-6">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 font-medium text-foreground [&::-webkit-details-marker]:hidden">
                <span>{t(`home.faq.${q}`)}</span>
                <ChevronDown
                  className="h-5 w-5 shrink-0 text-muted-foreground transition-transform duration-200 group-open:rotate-180"
                  strokeWidth={2}
                />
              </summary>
              <p className="pt-3 text-sm leading-relaxed text-muted-foreground md:text-base">
                {t(`home.faq.${q.replace('q', 'a')}`)}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
